import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartCreateResponse } from './multiCartMappers'
import { prepareItem } from 'lib/checkout/userCartPrepare'

type CreateRequest = Omit<paths['/api/carts/multi-carts']['post']['parameters']['body']['payload'], 'brand'>
type CreateResponse = paths['/api/carts/multi-carts']['post']['responses']['201']['content']['application/json']

export function createMultiCart(name: string, items: Array<App.Checkout.AnyItem>): Promise<App.MultiCartSummary> {
  const preparedItems = items.map(prepareItem)

  // TODO: remove this and change the villas type check
  const payload = {
    name,
    items: preparedItems,
  } as CreateRequest
  return request.post<CreateResponse, CreateRequest>('/api/carts/multi-carts', payload, { credentials: 'include' }).then(mapMultiCartCreateResponse)
}
